import {usernameHandleParse} from './parsers';

const social = {
  facebook:{
    title: "Facebook",
    placeholder: "Facebook username or page id",
    parse: usernameHandleParse,
    urlMutator: ({handle}) => `https://facebook.com/${(handle || '').replace(/[^a-zA-Z0-9_\-.]+/i, '')}`
  },
  instagram:{
    title: "Instagram",
    placeholder: "Instagram username",
    parse: usernameHandleParse,
    urlMutator: ({handle}) => `https://instagram.com/${(handle || '').replace(/[^a-zA-Z0-9_\-.]+/i, '')}`
  },
  twitter:{
    title: "Twitter",
    placeholder: "Twitter username",
    parse: usernameHandleParse,
    urlMutator: ({handle}) => `http://twitter.com/${(handle || '').replace(/[^a-zA-Z0-9_\-.]+/i, '')}`
  },
  youtube:{
    title: "Youtube",
    placeholder: "Youtube channel url",
    // parse: (value) => {
      // return (value || '').replace(/^(.*?)(channel\/|user\/|\/)([^\/]+?)(\/|)$/i, '$2$3').replace(/^\//, '').replace(/[^a-zA-Z0-9-_~.\/]+/i, '')
    // },
    urlMutator: ({handle}) => {
      let prefix = ''
      if (handle.match(/user\/|channel\//i)) {
        // prefix = ''
      }
      return handle.match(/^http/) ? handle : `https://youtube.com/${prefix}${(handle || '')}`
    }
  },
  tiktok:{
    title: "TikTok",
    placeholder: "TikTok username",
    parse: usernameHandleParse,
    urlMutator: ({handle}) => `https://www.tiktok.com/@${(handle || '').replace(/[^a-zA-Z0-9_\-.]+/i, '')}`
  },
  pinterest:{
    title: "Pinterest",
    placeholder: "Pinterest username",
    parse: usernameHandleParse,
    urlMutator: ({handle}) => `https://pinterest.com/${(handle || '').replace(/[^a-zA-Z0-9_\-.]+/i, '')}`
  },
  patreon:{
    title: "Patreon",
    placeholder: "Patreon username",
    parse: usernameHandleParse,
    urlMutator: ({handle}) => `https://www.patreon.com/${(handle || '').replace(/[^a-zA-Z0-9_\-.]+/i, '')}`
  },
  tumblr:{
    title: "Tumblr",
    placeholder: "Tumblr username",
    parse: usernameHandleParse,
    urlMutator: ({handle}) => `http://${(handle || '').replace(/[^a-zA-Z0-9_\-.]+/i, '')}.tumblr.com/`
  },
  vk:{
    title: "VK",
    placeholder: "VK username or page id",
    parse: usernameHandleParse,
    urlMutator: ({handle}) => `https://vk.com/${(handle || '').replace(/[@\s]+/i, '')}`
  },
  linkedin:{
    title: "LinkedIn",
    placeholder: "LinkedIn profile url",
    parse: (value) => {
      // return (value || '').replace(/[^a-zA-Z0-9-_~.\/]+/i, '')
      return (value || '').replace(/^(.*?)(company\/|\/)([^/]+?)(\/|)$/i, '$2$3').replace(/^\//, '').replace(/[^a-zA-Z0-9-_~./]+/i, '')
    },
    urlMutator: ({handle}) => {
      let prefix = 'in/'
      if (handle.match(/company\/|in\//i)) {
        prefix = ''
      }
      return `https://www.linkedin.com/${prefix}${(handle || '').replace(/[@\s]+/i, '')}`
    }
  },
  // email:{
//       title: "Email",
//       placeholder: "email",
//       fieldType: "email",
//       urlMutator: ({handle}) => `email:${(handle || '').replace(/\s+/i, '')}`
//     },
  snapchat: {
    title: "Snapchat",
    placeholder: "Snapchat username",
    parse: usernameHandleParse,
    urlMutator: ({handle}) => `https://snapchat.com/add/${(handle || '').replace(/^@/i, '')}`
  }
}

export default social;



// WEBPACK FOOTER //
// ./src/components/SmartLinks/schemes/social.js